import React, { useState, useEffect } from "react";
import "./Members.css";
import axios from "axios";
// const url = import.meta.env.VITE_BACKEND_URL;
const url = process.env.REACT_APP_BACKEND_URL;

const AddMember = () => {
  const [formData, setFormData] = useState({
    registertype: "",
    fname: "",
    mname: "",
    lname: "",
    moname: "",
    mobile: "",
    email: "",
    password: "",
    cpassword: "",
    dob: "",
    pob: "",
    country: "",
    region: "",
    district: "",
    residence: "",
    sex: "",
    elevel: "",
    PaymentTerms: "",
    bankname: "",
    bankaddress: "",
    accno: "",
    nokname1: "",
    nokaddress1: "",
    nokmobile1: "",
    nokname2: "",
    nokaddress2: "",
    nokmobile2: "",
    photo: null,
    identity: null,
  });

  const [registerTypes, setRegisterTypes] = useState([]);
  const [countries, setCountries] = useState([]);
  const [regions, setRegions] = useState([]);
  const [districts, setDistricts] = useState([]);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [emailExists, setEmailExists] = useState(false);
  const [mobileExists, setMobileExists] = useState(false);
  const [errors, setErrors] = useState({});
  const [alerts, setAlerts] = useState([]);

  useEffect(() => {
    const fetchDropdowns = async () => {
      try {
        const [typesRes, countriesRes, regionsRes, districtsRes] =
          await Promise.all([
            axios.get(`${url}/api/registrationtype`),
            axios.get(`${url}/api/country`),
            axios.get(`${url}/api/regions`),
            axios.get(`${url}/api/district`),
          ]);
        setRegisterTypes(typesRes.data.data || []);
        setCountries(countriesRes.data.data || []);
        setRegions(regionsRes.data.data || []);
        setDistricts(districtsRes.data.data || []);
      } catch (err) {
        console.error(err);
        showAlert("Failed to load form options", "error");
      }
    };
    fetchDropdowns();
  }, []);

  const showAlert = (message, type = "error") => {
    const id = Date.now();
    setAlerts(prev => [...prev, { id, message, type }]);
    
    // Auto remove after 5 seconds
    setTimeout(() => {
      setAlerts(prev => prev.filter(alert => alert.id !== id));
    }, 5000);
  };

  const checkEmailExists = async (email) => {
    try {
      const res = await axios.get(`${url}/api/members/check-email/${email}`);
      setEmailExists(res.data.exists);
      return res.data.exists;
    } catch (err) {
      console.error("Email check failed", err);
      return false;
    }
  };

  const checkMobileExists = async (mobile) => {
    try {
      const res = await axios.get(`${url}/api/members/check-mobile/${mobile}`);
      setMobileExists(res.data.exists);
      return res.data.exists;
    } catch (err) {
      console.error("Mobile check failed", err);
      return false;
    }
  };

  const validateFile = (file, fieldName) => {
    const maxSize = 5 * 1024 * 1024; // 5MB
    let allowedTypes = [];
    let allowedExtensions = [];

    if (fieldName === "photo") {
      allowedTypes = ["image/jpeg", "image/jpg", "image/png"];
      allowedExtensions = [".jpeg", ".jpg", ".png"];
    } else if (fieldName === "identity") {
      allowedTypes = ["image/jpeg", "image/jpg", "image/png", "application/pdf"];
      allowedExtensions = [".jpeg", ".jpg", ".png", ".pdf"];
    }

    // Get file extension
    const fileExtension = file.name.substring(file.name.lastIndexOf('.')).toLowerCase();
    
    if (!allowedTypes.includes(file.type) || !allowedExtensions.includes(fileExtension)) {
      showAlert(
        fieldName === "photo"
          ? "Photo must be JPEG, JPG or PNG format only"
          : "Identity must be PDF, JPEG, JPG or PNG format only"
      );
      return false;
    }

    if (file.size > maxSize) {
      showAlert("File too large. Max 5MB allowed");
      return false;
    }

    return true;
  };

  const validateField = (name, value) => {
    let error = "";
    
    switch (name) {
      case "email":
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (!emailRegex.test(value)) {
          error = "Please enter a valid email address";
        }
        break;
      case "mobile":
        const mobileRegex = /^[0-9]{10,15}$/;
        if (!mobileRegex.test(value)) {
          error = "Please enter a valid mobile number";
        }
        break;
      case "password":
        if (value.length < 6) {
          error = "Password must be at least 6 characters long";
        }
        break;
      case "cpassword":
        if (value !== formData.password) {
          error = "Passwords do not match";
        }
        break;
      default:
        break;
    }
    
    setErrors(prev => ({ ...prev, [name]: error }));
    return error === "";
  };

  const handleChange = async (e) => {
    const { name, value, files } = e.target;
    
    if (files && files.length > 0) {
      const file = files[0];
      if (validateFile(file, name)) {
        setFormData({ ...formData, [name]: file });
      } else {
        e.target.value = ""; // Reset file input if invalid
      }
    } else {
      setFormData({ ...formData, [name]: value });
      validateField(name, value);
    }

    if (name === "email" && value) {
      await checkEmailExists(value);
    }
    
    if (name === "mobile" && value) {
      await checkMobileExists(value);
    }
  };

  const validateForm = () => {
    const newErrors = {};
    let isValid = true;

    // Required fields validation
    const requiredFields = [
      "registertype", "fname", "mname", "lname", "moname", "mobile", "email",
      "password", "cpassword", "dob", "pob", "country", "region", "district",
      "residence", "sex", "elevel", "PaymentTerms", "bankaddress", "nokname1",
      "nokaddress1", "nokmobile1"
    ];

    requiredFields.forEach(field => {
      if (!formData[field]) {
        newErrors[field] = "This field is required";
        isValid = false;
      }
    });

    // Password validation
    if (formData.password.length < 6) {
      newErrors.password = "Password must be at least 6 characters long";
      isValid = false;
    }

    if (formData.password !== formData.cpassword) {
      newErrors.cpassword = "Passwords do not match";
      isValid = false;
    }

    // Email validation
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(formData.email)) {
      newErrors.email = "Please enter a valid email address";
      isValid = false;
    }

    // Mobile validation
    const mobileRegex = /^[0-9]{10,15}$/;
    if (!mobileRegex.test(formData.mobile)) {
      newErrors.mobile = "Please enter a valid mobile number";
      isValid = false;
    }

    // File validation
    if (!formData.photo) {
      newErrors.photo = "Photo is required";
      isValid = false;
    }

    if (!formData.identity) {
      newErrors.identity = "Identity document is required";
      isValid = false;
    }

    setErrors(newErrors);
    return isValid;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!validateForm()) {
      showAlert("Please fix the errors in the form");
      return;
    }
    
    if (emailExists) {
      showAlert("This email is already registered");
      return;
    }
    
    if (mobileExists) {
      showAlert("This mobile number is already registered");
      return;
    }

    setIsSubmitting(true);

    try {
      const data = new FormData();
      Object.keys(formData).forEach((key) => {
        if (formData[key] !== null && formData[key] !== undefined) {
          data.append(key, formData[key]);
        }
      });

      await axios.post(`${url}/api/members`, data, {
        headers: { "Content-Type": "multipart/form-data" },
      });

      showAlert("Registration Successful! 🎉", "success");

      // Reset form
      setFormData({
        registertype: "",
        fname: "",
        mname: "",
        lname: "",
        moname: "",
        mobile: "",
        email: "",
        password: "",
        cpassword: "",
        dob: "",
        pob: "",
        country: "",
        region: "",
        district: "",
        residence: "",
        sex: "",
        elevel: "",
        PaymentTerms: "",
        bankname: "",
        bankaddress: "",
        accno: "",
        nokname1: "",
        nokaddress1: "",
        nokmobile1: "",
        nokname2: "",
        nokaddress2: "",
        nokmobile2: "",
        photo: null,
        identity: null,
      });
      
      setErrors({});
      setEmailExists(false);
      setMobileExists(false);
      
      // Reset file inputs
      document.getElementById("photo").value = "";
      document.getElementById("identity").value = "";
    } catch (err) {
      console.error(err.response?.data || err.message);

      // Handle specific error cases
      if (err.response?.data?.message) {
        const errorMessage = err.response.data.message;

        if (
          errorMessage.includes("email") &&
          errorMessage.includes("duplicate")
        ) {
          showAlert("This email address is already registered");
        } else if (
          errorMessage.includes("mobile") &&
          errorMessage.includes("duplicate")
        ) {
          showAlert("Mobile number is already registered");
        } else if (err.response?.data?.success === false) {
          // Handle file validation errors from backend
          showAlert(err.response.data.message);
        } else {
          showAlert(`Registration Failed: ${errorMessage}`);
        }
      } else {
        showAlert("Registration Failed: Please try again later");
      }
    } finally {
      setIsSubmitting(false);
    }
  };

  const filteredRegions = regions.filter(
    (r) => (r.country?._id || r.country) === formData.country
  );
  const filteredDistricts = districts.filter(
    (d) => (d.region?._id || d.region) === formData.region
  );

  return (
    <div className="register-container">
      <h2>Register New Member</h2>
      
      <div className="alert-container">
        {alerts.map(alert => (
          <div key={alert.id} className={`alert ${alert.type}`}>
            {alert.message}
          </div>
        ))}
      </div>

      <form onSubmit={handleSubmit} className="register-form">
        {/* Personal Information Section */}
        <fieldset>
          <legend>Personal Information</legend>

          <div className="form-group">
            <label htmlFor="registertype" className="required">Registration Type</label>
            <select
              id="registertype"
              name="registertype"
              value={formData.registertype}
              onChange={handleChange}
              required
              className={errors.registertype ? "error" : ""}
            >
              <option value="">Select registration type</option>
              {registerTypes.map((t) => (
                <option key={t._id} value={t._id}>
                  {t.name}- ${t.amount}
                </option>
              ))}
            </select>
            {errors.registertype && <span className="error-text">{errors.registertype}</span>}
          </div>

          <div className="form-group">
            <label htmlFor="fname" className="required">First Name</label>
            <input
              id="fname"
              type="text"
              name="fname"
              value={formData.fname}
              onChange={handleChange}
              placeholder="Enter first name"
              required
              className={errors.fname ? "error" : ""}
            />
            {errors.fname && <span className="error-text">{errors.fname}</span>}
          </div>

          <div className="form-group">
            <label htmlFor="mname" className="required">Middle Name</label>
            <input
              id="mname"
              type="text"
              name="mname"
              value={formData.mname}
              onChange={handleChange}
              placeholder="Enter middle name"
              required
              className={errors.mname ? "error" : ""}
            />
            {errors.mname && <span className="error-text">{errors.mname}</span>}
          </div>

          <div className="form-group">
            <label htmlFor="lname" className="required">Last Name</label>
            <input
              id="lname"
              type="text"
              name="lname"
              value={formData.lname}
              onChange={handleChange}
              placeholder="Enter last name"
              required
              className={errors.lname ? "error" : ""}
            />
            {errors.lname && <span className="error-text">{errors.lname}</span>}
          </div>

          <div className="form-group">
            <label htmlFor="moname" className="required">Mother's Name</label>
            <input
              id="moname"
              type="text"
              name="moname"
              value={formData.moname}
              onChange={handleChange}
              placeholder="Enter mother's name"
              required
              className={errors.moname ? "error" : ""}
            />
            {errors.moname && <span className="error-text">{errors.moname}</span>}
          </div>

          <div className="form-group">
            <label htmlFor="mobile" className="required">Mobile Number</label>
            <input
              id="mobile"
              type="tel"
              name="mobile"
              value={formData.mobile}
              onChange={handleChange}
              placeholder="Enter mobile number"
              required
              className={errors.mobile ? "error" : ""}
            />
            {errors.mobile && <span className="error-text">{errors.mobile}</span>}
            {mobileExists && (
              <span className="error-text">This mobile number is already registered</span>
            )}
          </div>

          <div className="form-group">
            <label htmlFor="email" className="required">Email Address</label>
            <input
              id="email"
              type="email"
              name="email"
              value={formData.email}
              onChange={handleChange}
              placeholder="Enter email address"
              required
              className={errors.email ? "error" : ""}
            />
            {errors.email && <span className="error-text">{errors.email}</span>}
            {emailExists && (
              <span className="error-text">This email is already registered</span>
            )}
          </div>
          
          <div className="form-group">
            <label htmlFor="password" className="required">Password</label>
            <input
              id="password"
              type="password"
              name="password"
              value={formData.password}
              onChange={handleChange}
              placeholder="Create password"
              required
              className={errors.password ? "error" : ""}
            />
            {errors.password && <span className="error-text">{errors.password}</span>}
          </div>

          <div className="form-group">
            <label htmlFor="cpassword" className="required">Confirm Password</label>
            <input
              id="cpassword"
              type="password"
              name="cpassword"
              value={formData.cpassword}
              onChange={handleChange}
              placeholder="Confirm password"
              required
              className={errors.cpassword ? "error" : ""}
            />
            {errors.cpassword && <span className="error-text">{errors.cpassword}</span>}
          </div>

          <div className="form-group">
            <label htmlFor="dob" className="required">Date of Birth</label>
            <input
              id="dob"
              type="date"
              name="dob"
              value={formData.dob}
              onChange={handleChange}
              required
              className={errors.dob ? "error" : ""}
            />
            {errors.dob && <span className="error-text">{errors.dob}</span>}
          </div>

          <div className="form-group">
            <label htmlFor="pob" className="required">Place of Birth</label>
            <input
              id="pob"
              type="text"
              name="pob"
              value={formData.pob}
              onChange={handleChange}
              placeholder="Enter place of birth"
              required
              className={errors.pob ? "error" : ""}
            />
            {errors.pob && <span className="error-text">{errors.pob}</span>}
          </div>
        </fieldset>

        {/* Location Information Section */}
        <fieldset>
          <legend>Location Information</legend>

          <div className="form-group">
            <label htmlFor="country" className="required">Country</label>
            <select
              id="country"
              name="country"
              value={formData.country}
              onChange={handleChange}
              required
              className={errors.country ? "error" : ""}
            >
              <option value="">Select country</option>
              {countries.map((c) => (
                <option key={c._id} value={c._id}>
                  {c.name}
                </option>
              ))}
            </select>
            {errors.country && <span className="error-text">{errors.country}</span>}
          </div>

          <div className="form-group">
            <label htmlFor="region" className="required">Region</label>
            <select
              id="region"
              name="region"
              value={formData.region}
              onChange={handleChange}
              required
              disabled={!formData.country}
              className={errors.region ? "error" : ""}
            >
              <option value="">Select region</option>
              {filteredRegions.map((r) => (
                <option key={r._id} value={r._id}>
                  {r.name}
                </option>
              ))}
            </select>
            {!formData.country && (
              <span className="field-note">Please select a country first</span>
            )}
            {errors.region && <span className="error-text">{errors.region}</span>}
          </div>

          <div className="form-group">
            <label htmlFor="district" className="required">District</label>
            <select
              id="district"
              name="district"
              value={formData.district}
              onChange={handleChange}
              required
              disabled={!formData.region}
              className={errors.district ? "error" : ""}
            >
              <option value="">Select district</option>
              {filteredDistricts.map((d) => (
                <option key={d._id} value={d._id}>
                  {d.name}
                </option>
              ))}
            </select>
            {!formData.region && (
              <span className="field-note">Please select a region first</span>
            )}
            {errors.district && <span className="error-text">{errors.district}</span>}
          </div>

          <div className="form-group">
            <label htmlFor="residence" className="required">Residence Address</label>
            <input
              id="residence"
              type="text"
              name="residence"
              value={formData.residence}
              onChange={handleChange}
              placeholder="Enter residence address"
              required
              className={errors.residence ? "error" : ""}
            />
            {errors.residence && <span className="error-text">{errors.residence}</span>}
          </div>
        </fieldset>

        {/* Additional Information Section */}
        <fieldset>
          <legend>Additional Information</legend>

          <div className="form-group">
            <label htmlFor="sex" className="required">Gender</label>
            <select
              id="sex"
              name="sex"
              value={formData.sex}
              onChange={handleChange}
              required
              className={errors.sex ? "error" : ""}
            >
              <option value="">Select gender</option>
              <option value="male">Male</option>
              <option value="female">Female</option>
            </select>
            {errors.sex && <span className="error-text">{errors.sex}</span>}
          </div>

          <div className="form-group">
            <label htmlFor="elevel" className="required">Education Level</label>
            <input
              id="elevel"
              type="text"
              name="elevel"
              value={formData.elevel}
              onChange={handleChange}
              placeholder="Enter education level"
              required
              className={errors.elevel ? "error" : ""}
            />
            {errors.elevel && <span className="error-text">{errors.elevel}</span>}
          </div>
          <div className="form-group">
            <label htmlFor="sex" className="required">Gender</label>
            <select
              id="PaymentTerms"
              name="PaymentTerms"
              value={formData.PaymentTerms}
              onChange={handleChange}
              required
              className={errors.PaymentTerms ? "error" : ""}
            >
              <option value="">Select Payment Terms</option>
              <option value="Annual">Annual payment</option>
             
            </select>
            {errors.PaymentTerms && <span className="error-text">{errors.PaymentTerms}</span>}
          </div>

         
        </fieldset>

        {/* Bank Information Section */}
        <fieldset>
          <legend>Bank Information</legend>

          <div className="form-group">
            <label htmlFor="bankname">Bank Name</label>
            <input
              id="bankname"
              type="text"
              name="bankname"
              value={formData.bankname}
              onChange={handleChange}
              placeholder="Enter bank name (optional)"
            />
          </div>

          <div className="form-group">
            <label htmlFor="bankaddress" className="required">Bank Address</label>
            <input
              id="bankaddress"
              type="text"
              name="bankaddress"
              value={formData.bankaddress}
              onChange={handleChange}
              placeholder="Enter bank address"
              required
              className={errors.bankaddress ? "error" : ""}
            />
            {errors.bankaddress && <span className="error-text">{errors.bankaddress}</span>}
          </div>

          <div className="form-group">
            <label htmlFor="accno">Account Number</label>
            <input
              id="accno"
              type="text"
              name="accno"
              value={formData.accno}
              onChange={handleChange}
              placeholder="Enter account number (optional)"
            />
          </div>
        </fieldset>

        {/* Next of Kin Section */}
        <fieldset>
          <legend>Next of Kin Information</legend>

          <div className="form-group">
            <label htmlFor="nokname1" className="required">Next of Kin 1 Name</label>
            <input
              id="nokname1"
              type="text"
              name="nokname1"
              value={formData.nokname1}
              onChange={handleChange}
              placeholder="Enter name"
              required
              className={errors.nokname1 ? "error" : ""}
            />
            {errors.nokname1 && <span className="error-text">{errors.nokname1}</span>}
          </div>

          <div className="form-group">
            <label htmlFor="nokaddress1" className="required">Next of Kin 1 Address</label>
            <input
              id="nokaddress1"
              type="text"
              name="nokaddress1"
              value={formData.nokaddress1}
              onChange={handleChange}
              placeholder="Enter address"
              required
              className={errors.nokaddress1 ? "error" : ""}
            />
            {errors.nokaddress1 && <span className="error-text">{errors.nokaddress1}</span>}
          </div>

          <div className="form-group">
            <label htmlFor="nokmobile1" className="required">Next of Kin 1 Mobile</label>
            <input
              id="nokmobile1"
              type="tel"
              name="nokmobile1"
              value={formData.nokmobile1}
              onChange={handleChange}
              placeholder="Enter mobile number"
              required
              className={errors.nokmobile1 ? "error" : ""}
            />
            {errors.nokmobile1 && <span className="error-text">{errors.nokmobile1}</span>}
          </div>

          <div className="form-group">
            <label htmlFor="nokname2">Next of Kin 2 Name</label>
            <input
              id="nokname2"
              type="text"
              name="nokname2"
              value={formData.nokname2}
              onChange={handleChange}
              placeholder="Enter name (optional)"
            />
          </div>

          <div className="form-group">
            <label htmlFor="nokaddress2">Next of Kin 2 Address</label>
            <input
              id="nokaddress2"
              type="text"
              name="nokaddress2"
              value={formData.nokaddress2}
              onChange={handleChange}
              placeholder="Enter address (optional)"
            />
          </div>

          <div className="form-group">
            <label htmlFor="nokmobile2">Next of Kin 2 Mobile</label>
            <input
              id="nokmobile2"
              type="tel"
              name="nokmobile2"
              value={formData.nokmobile2}
              onChange={handleChange}
              placeholder="Enter mobile number (optional)"
            />
          </div>
        </fieldset>

        {/* Documents Section */}
        <fieldset>
          <legend>Documents</legend>

          <div className="form-group">
            <label htmlFor="photo" className="required">Photo</label>
            <input
              id="photo"
              type="file"
              name="photo"
              onChange={handleChange}
              accept="image/*"
              required
              className={errors.photo ? "error" : ""}
            />
            {formData.photo && (
              <span className="file-info">Selected: {formData.photo.name}</span>
            )}
            {errors.photo && <span className="error-text">{errors.photo}</span>}
          </div>

          <div className="form-group">
            <label htmlFor="identity" className="required">Identity Document</label>
            <input
              id="identity"
              type="file"
              name="identity"
              onChange={handleChange}
              accept=".pdf,.jpg,.png"
              required
              className={errors.identity ? "error" : ""}
            />
            {formData.identity && (
              <span className="file-info">
                Selected: {formData.identity.name}
              </span>
            )}
            {errors.identity && <span className="error-text">{errors.identity}</span>}
          </div>
        </fieldset>

        <button  type="submit" disabled={isSubmitting}>
          {isSubmitting ? "Registering..." : "Register Member"}
        </button>
      </form>
    </div>
  );
};

export default AddMember;